//src/Components/Buttons/DeleteButton/index.tsx
import { DeleteIcon } from 'assets/icons';

interface DeleteButtonProps {
  onClick?: () => void;
}

export default function DeleteButton({ onClick }: DeleteButtonProps) {
  return (
    <div
      className="cursor-pointer border border-red-200 rounded-lg hover:shadow-lg w-10 h-8 grid "
      onClick={onClick}
    >
      <DeleteIcon className="place-self-center" />
    </div>
  );
}
